export enum Ordinal {
  Primeiro = 1,
  Segundo,
  Terceiro,
  Quarto,
  Quinto
}
